import { ConstValues } from '@/ConstValues';
import { ItemState, RollDirection } from './ItemModel';

export class Address {
  FullAddress!: string;
  CompanyName!: string;
  City!: string;
  State!: string;
  Province!: string;
  ShouldUseProvince!: boolean;
  IsDefault!: boolean;
  Id!: string;
  IsAResidence!: boolean;
  Country!: Country;
  Attn!: string;
  Street1!: string;
  Street2!: string;
  ZipCode!: string;
  DefaultMaximumOD!: number;
  PhoneNumber: PhoneNumber;
  Email!: Email;
  Options!: AddressOption;
  IsCustomerPickup!: boolean;
  IsBilling!: boolean;
  Status!: ItemState;
  HasChanged!: boolean;

  constructor(rawItem?: any) {
    this.HasChanged = false;
    this.Status = ItemState.New;
    this.FullAddress = '';
    if (rawItem) {
      this.FullAddress = rawItem.FullAddress;
      this.Id = rawItem.Id;
      this.IsAResidence = rawItem.IsAResidence;
      this.CompanyName = rawItem.CompanyName;
      this.City = rawItem.City;
      this.State = rawItem.State;
      this.Province = rawItem.Province;
      this.Country = new Country(rawItem.Country);
      this.ShouldUseProvince = rawItem.ShouldUseProvince;
      this.IsDefault = rawItem.IsDefault;
      this.Attn = rawItem.Attn;
      this.Street1 = rawItem.Street1;
      this.Street2 = rawItem.Street2;
      this.IsCustomerPickup = rawItem.IsCustomerPickup;
      this.ZipCode = rawItem.ZipCode;
      this.PhoneNumber = new PhoneNumber(rawItem.Phone);
      this.Options = new AddressOption(rawItem.Options);
      this.Email = new Email(rawItem.Email);
      this.IsCustomerPickup = rawItem.IsCustomerPickup;
      this.IsBilling = rawItem.IsBilling;
      this.Status = ItemState.Edit;
    } else {
      this.Country = new Country();
      this.PhoneNumber = new PhoneNumber();
      this.Email = new Email();
      this.Options = new AddressOption();
    }
  }
  IsInternational() {
    return this.Country.Id > 1;
  }
}

export class AddressOption {
  Id!: number;
  BrandLabel!: string;
  OD!: number;
  ShipToId!: number;
  RollDirectionId!: number;
  constructor(rawItem?: any) {
    if (rawItem) {
      this.BrandLabel = rawItem.BrandLabel;
      this.OD = rawItem.OD;
      this.ShipToId = rawItem.ShipToId;
      this.RollDirectionId = rawItem.RollDirectionId;
      this.Id = rawItem.Id;
    } else {
      this.OD = ConstValues.DEFAULT_MAX_OD;
    }
  }
}

export class ShippingVendor {
  Id!: number;
  Name!: string;
  constructor(rawItem?: any) {
    if (rawItem) {
      this.Id = rawItem.Id;
      this.Name = rawItem.Name;
    }
  }
}

export class PhoneNumber {
  Id: string;
  PhoneNumber: string;
  constructor(rawItem?: any) {
    this.Populate(rawItem);
  }
  Populate(rawItem: any) {
    if (rawItem) {
      this.Id = rawItem.PhoneId;
      this.PhoneNumber = rawItem.PhoneNumber;
    } else {
      this.Id = '';
      this.PhoneNumber = '';
    }
  }
}
export class Email {
  Id!: string;
  EmailAddress!: string;
  constructor(rawItem?: any) {
    this.Populate(rawItem);
  }
  Populate(rawItem: any) {
    if (rawItem) {
      this.Id = rawItem.Id;
      this.EmailAddress = rawItem.EmailAddress;
    }
  }
}

export class Country {
  Id: number = 0;
  CountryValue!: string;
  ShouldUseProvince!: boolean;
  constructor(rawItem?: any) {
    this.Populate(rawItem);
  }
  Populate(rawItem: any) {
    if (rawItem) {
      this.Id = rawItem.Id;
      this.CountryValue = rawItem.CountryValue;
      this.ShouldUseProvince = rawItem.ShouldUseProvince;
    } else {
      this.Id = 1;
      this.CountryValue = 'USA';
      this.ShouldUseProvince = false;
    }
  }
}
